import { combineReducers } from "redux"
import entities from "./entities"
import processes from "./processes"

export default combineReducers({
  entities,
  processes,
})
